import { schema, types } from 'papr'

export const magicLinkSchema = schema(
	{
		email: types.string({ required: true }),
		magicLinkId: types.string({ required: true }),
		updatedAt: types.date(),
		isActive: types.boolean(),
	},
	{
		timestamps: true,
		defaults: {
			updatedAt: new Date(),
		},
	},
)

export type MagicLinkDocument = (typeof magicLinkSchema)[0]
export type MagicLinkDefaults = (typeof magicLinkSchema)[1]
